import { State } from '@meraki-internal/state';
import { HistoryViewModel } from '../support/HistoryViewModel';

interface IIntroScreenState {
    visible: boolean;
}

export class IntroScreenState extends State<IIntroScreenState> {

    static inject = () => [HistoryViewModel];

    constructor(
        history: HistoryViewModel
    ) {
        // Check for ?intro=true query param (set during auth callback after account creation)
        const params = history.getCurrentSearchParams();
        const introFromParam = params.get('intro') === 'true';

        super({
            visible: introFromParam
        });

        // Defer URL cleanup so it doesn't trigger state updates during render
        if (introFromParam) {
            queueMicrotask(() => history.removeSearchParam('intro'));
        }
    }

    show = () => {
        this.setState({ visible: true });
    };

    hide = () => {
        this.setState({ visible: false });
    };

    isVisible = (): boolean => {
        return this.state.visible;
    };
}
